import React from 'react';
import {Controller} from 'react-hook-form';
import {BenefitTag, Checkbox} from '@bonprix/design-system';

export default function NewsletterCheckBoxField({name, control, label, benefit1, benefit2, changeCheckboxTrackingCallback}) {
    return (
        <div className="bg-clr-bg-main-light p-4">
            <div className="inline-flex gap-2">
                {benefit1 && <BenefitTag variant="price">{benefit1}</BenefitTag>}
                {benefit2 && <BenefitTag className="ml-1" variant="price">{benefit2}</BenefitTag>}
            </div>
            <Controller
                control={control}
                name={name}
                render={({field}) => (
                    <label className="inline-flex content-start gap-2">
                        <Checkbox
                            {...field}
                            value={field.value}
                            checked={field.value}
                            onChange={(e) => { field.onChange(e); changeCheckboxTrackingCallback(e); } }
                        />
                        <span className="typography-input-text pt-3" dangerouslySetInnerHTML={{__html: label}}/>
                    </label>

                )}
            />
        </div>
    );
}
